import React, {memo, ReactNode} from 'react';
import './index.scss';
import {useWindowSize} from '../../hooks/window-size';
import {ColumnComponent} from './component';

export type ColumnProps = {
    children?: ReactNode;
    min: number;
    max: number;
};

export const Column = memo(function Column({children, min, max}: ColumnProps) {
    const [innerWidth] = useWindowSize();
    return (
        <ColumnComponent min={min} max={max} innerWidth={innerWidth}>
            {children}
        </ColumnComponent>
    );
});
